import { Feature } from '../../types/service';

export const offreIAFeatures: Feature[] = [
    {
        iconName: "Zap",
        title: "Accès illimité",
        description: "Profitez d’un accès sans limite aux modèles ChatGPT et Claude, à tout moment."
    },
    {
        iconName: "Rocket",
        title: "Réponses rapides",
        description: "Bénéficiez d’une vitesse de traitement optimisée pour des réponses instantanées."
    },
    {
        iconName: "Sparkles",
        title: "Modèles IA Avancés",
        description: "Accédez aux versions les plus performantes des modèles ChatGPT et Claude."
    },
    {
        iconName: "Sparkles",
        title: "Génération de contenu",
        description: "Créez des textes, synthèses, analyses, code et contenus créatifs sans restriction."
    },
    {
        iconName: "Rocket",
        title: "Navigation & Recherche",
        description: "Obtenez des informations actualisées et approfondies pour vos travaux scolaires, universitaires."
    },
    {
        iconName: "Rocket",
        title: "Analyse de données",
        description: "Analysez des documents, des données complexes et produisez des synthèses claires."
    }
];

export const offreIABenefits = [
    {
        title: "Gratuit pour les Étudiants",
        description: "Accès offert aux étudiants inscrits sur France Student pendant la phase Beta."
    },
    {
        title: "Accès Premium Centralisé",
        description: "Une seule offre pour utiliser ChatGPT et Claude sans limite."
    },
    {
        title: "Mises à Jour Continues",
        description: "Bénéficiez automatiquement des améliorations et nouvelles versions des modèles."
    }
];

export const offreIARequirements = [
    {
        title: "Statut Étudiant Validé",
        description: "Être étudiant et avoir validé votre statut sur la plateforme France Student."
    },
    {
        title: "Compte France Student Actif",
        description: "Disposer d’un compte actif sur la plateforme pour accéder à l’Offre IA."
    },
    {
        title: "Inscription à l’Offre IA",
        description: "Compléter la demande d’activation pour bénéficier de l’accès."
    }
];